import API_URL from "../config/apiConfig";

// Uploaded files (e.g. menu item photos) are stored as root-relative
// "/uploads/..." paths; prefix them with the API server so they also load
// when the API is on a different origin. Anything else is used as-is.
export const resolveMediaUrl = (value) => {
  if (!value) return "";
  return value.startsWith("/uploads/") ? `${API_URL}${value}` : value;
};
